import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectBibEntities, selectCatalogBibEntities } from 'app/selectors/EntitiesSelector';
import { trackContentClick, trackHoldingsConsumeAccess, trackHoldingsView } from 'app/actions/AnalyticsGa4Actions';
import { METADATA_CATEGORY_TYPE, UI_COMPONENT_TYPE, UI_CONTAINER_TYPE } from 'app/constants/AnalyticsGa4Constants';
import AlternativeFormatBib from './AlternativeFormatBib';

const AlternativeFormatBibContainer = ({ metadataId }) => {
  const dispatch = useDispatch();
  const bibs = useSelector(selectBibEntities);
  const catalogBibs = useSelector(selectCatalogBibEntities);
  const listState = useSelector(state => state.get('list') ?? Immutable.Map());

  const bib = bibs.get(metadataId);
  const catalogBib = catalogBibs.get(metadataId);
  const pagination = listState.get('pagination')?.toJS() ?? {};

  const trackItemTitleClick = ({ linkText }) => {
    const { count: numTotalItems, page } = pagination;

    const title = bib?.getIn(['briefInfo', 'title']) || catalogBib?.getIn(['brief', 'title']);

    dispatch(
      trackContentClick({
        bibId: metadataId,
        metadata: {
          metadata_category_type: METADATA_CATEGORY_TYPE.BIBLIOGRAPHIC_DETAILS_TITLE,
          metadata_value: title
        },
        ui: {
          ui_component_label: linkText,
          ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
          ui_container_type: UI_CONTAINER_TYPE.ITEM_ALL_FORMATS,
          ui_content_page: page,
          ui_content_total_count: numTotalItems
        }
      })
    );
  };

  const trackAvailabilityClick = ({ linkText }) => {
    const { count: numTotalItems, page } = pagination;

    dispatch(
      trackHoldingsView({
        bibId: metadataId,
        ui: {
          ui_component_label: linkText,
          ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
          ui_container_type: UI_CONTAINER_TYPE.ITEM_ALL_FORMATS,
          ui_content_page: page,
          ui_content_total_count: numTotalItems
        }
      })
    );
  };

  const trackDigitalResourceClick = ({ linkText, url }) => {
    const { count: numTotalItems, page } = pagination;

    dispatch(
      trackHoldingsConsumeAccess({
        bibId: metadataId,
        metadata: {
          metadata_category_type: METADATA_CATEGORY_TYPE.HOLDINGS_ELECTRONIC_RESOURCE,
          metadata_value: url
        },
        ui: {
          ui_component_label: linkText,
          ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
          ui_container_type: UI_CONTAINER_TYPE.ITEM_ALL_FORMATS,
          ui_content_page: page,
          ui_content_total_count: numTotalItems
        }
      })
    );
  };

  if (!(bib && catalogBib)) {
    return null;
  }

  return (
    <AlternativeFormatBib
      bib={bib}
      catalogBib={catalogBib}
      trackDigitalResourceClick={trackDigitalResourceClick}
      trackItemTitleClick={trackItemTitleClick}
      trackAvailabilityClick={trackAvailabilityClick}
    />
  );
};

AlternativeFormatBibContainer.propTypes = {
  metadataId: PropTypes.string.isRequired
};

export default AlternativeFormatBibContainer;
